export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[900px] mx-auto">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          联系我们
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-12">
          投稿、合作与反馈
        </p>
        <div className="bg-background-100 rounded-2xl p-6 md:p-10 border border-background-200/70">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="text-center p-5 bg-background-50 rounded-xl border border-background-200/50">
              <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 rounded-full bg-primary-100 text-primary-500">
                <i className="ri-mail-line text-xl"></i>
              </div>
              <h3 className="font-heading font-semibold text-sm text-foreground-900 mb-2">投稿爆料</h3>
              <p className="text-xs text-foreground-600 leading-relaxed">
                如果你有独家51吃瓜爆料线索，欢迎通过邮件联系我们投稿。
              </p>
              <span className="inline-block mt-3 text-xs text-primary-500 font-medium cursor-pointer">
                tips@51chigua.com
              </span>
            </div>
            <div className="text-center p-5 bg-background-50 rounded-xl border border-background-200/50">
              <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 rounded-full bg-accent-100 text-accent-600">
                <i className="ri-team-line text-xl"></i>
              </div>
              <h3 className="font-heading font-semibold text-sm text-foreground-900 mb-2">商务合作</h3>
              <p className="text-xs text-foreground-600 leading-relaxed">
                广告投放、品牌合作等商务事宜请通过邮件洽谈。
              </p>
              <span className="inline-block mt-3 text-xs text-accent-600 font-medium cursor-pointer">
                biz@51chigua.com
              </span>
            </div>
            <div className="text-center p-5 bg-background-50 rounded-xl border border-background-200/50">
              <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 rounded-full bg-secondary-100 text-secondary-600">
                <i className="ri-feedback-line text-xl"></i>
              </div>
              <h3 className="font-heading font-semibold text-sm text-foreground-900 mb-2">意见反馈</h3>
              <p className="text-xs text-foreground-600 leading-relaxed">
                对51吃瓜最新网址有任何建议或意见，欢迎随时反馈。
              </p>
              <span className="inline-block mt-3 text-xs text-secondary-600 font-medium cursor-pointer">
                feedback@51chigua.com
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}